var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26.559,
    height: 25.259,
    viewBox: "0 0 26.559 25.259",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_214929",
    "data-name": "Path 214929",
    d: "M13.28,0,9.86,9.255,0,9.647,7.747,15.76l-2.674,9.5L13.28,19.78l8.207,5.479-2.674-9.5,7.746-6.113L16.7,9.255Z",
    transform: "translate(0 0)",
    fill: "#ff9f00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.1f80c230a61eba6446b560f1e5c3d1ec.svg";
export { ForwardRef as ReactComponent };